<template>
  <chart-card title="Gasto médio por cliente" filter-button :filter-type.sync="filterType" :data="chartData" :chart-loading="loading" is-currency />
</template>

<script>
import ChartCard from '@/components/ChartCard.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import * as helpers from '@/config/helpers.js'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  data: () => ({
    filterType: 'mensal',
    gastoMedioPorCliente: [],
    loading: true,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    filtro() {
      return {
        unidades: this.stateFilters.unitsConfiguration,
        fidelidade: '1',
        segmentos: this.stateFilters.segments,
      }
    },
    chartData() {
      return {
        labels: [...this.gastoMedioPorCliente.map((object) => object.data)],
        datasets: [
          {
            label: 'Gasto médio por cliente',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...this.gastoMedioPorCliente.map((object) => object.valor)],
            fill: false,
          },
        ],
      }
    },
  },
  watch: {
    filterType() {
      this.getData()
    },
  },
  async mounted() {
    this.$bus.$on('filter', this.getData)

    this.$nextTick(async () => {
      await this.getData()
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      gastoMedio: 'gasto-medio',
    }),

    async getData() {
      try {
        this.loading = true
        if (this.filterType === 'mensal') {
          await this.gastoMedio({ group_field: 'ano,mes', ...this.filtro }).then((data) => {
            this.gastoMedioPorCliente = helpers.agrupamentoMensal(data, 'VAL_GASTO_MEDIO_POR_CLIENTE')
          })
        }

        if (this.filterType === 'semanal') {
          await this.gastoMedio({ group_field: 'ano,semana', ...this.filtro }).then((data) => {
            this.gastoMedioPorCliente = helpers.agrupamentoSemanal(data, 'VAL_GASTO_MEDIO_POR_CLIENTE')
          })
        }

        if (this.filterType === 'diario') {
          await this.gastoMedio({ group_field: 'anomesdia', ...this.filtro }).then((data) => {
            this.gastoMedioPorCliente = helpers.agrupamentoDiario(data, 'VAL_GASTO_MEDIO_POR_CLIENTE')
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
